// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelWriteOff_PanelWriteOff__TcSC7 {
  position: fixed;
  top: 0;
  right: 0;
  width: 85%;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 30px;
}

.PanelWriteOff_header__F7V-8 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.PanelWriteOff_backButton__JZB4O {
    display: flex;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 15px;
    height: 16.2px;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.PanelWriteOff_backText__Mj8U4 {
    font-weight: bold;
    font-size: 18px;
    padding-left: 20px;
}

.PanelWriteOff_text__4hMle {
    margin-bottom: 10px;
    color: rgb(108, 106, 106);
}

.PanelWriteOff_title__7HxvF {
  font-size: 16px;
  margin-bottom: 10px;
  color: black;
}

.PanelWriteOff_change__eiUgl {
    color: rgba(29, 135, 82, 1);
}

.PanelWriteOff_content__m00WJ {
    gap: 20px;
    display: flex;
}

.PanelWriteOff_content__m00WJ div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 200px;
    border-radius: 5px;
    padding: 1.25rem 1.25rem;
    background: white;
}

.PanelWriteOff_secondBlock__HP7q0 .PanelWriteOff_price__l\\+Ibv {
    color: brown;
    font-size: 28px;
}

.PanelWriteOff_thirdBlock__bis9b .PanelWriteOff_price__l\\+Ibv {
    font-size: 28px;
    color: blue;
}

.PanelWriteOff_fourthBlock__3HWCZ .PanelWriteOff_price__l\\+Ibv {
    font-size: 28px;
    color: chocolate;
}

.PanelWriteOff_searchBlock__iRqls {
  position: relative;
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}

.PanelWriteOff_search__T20DJ {
  flex: 1 1;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ccc;
}

.PanelWriteOff_addProduct__IU232,
.PanelWriteOff_endProduct__\\+o8PF {
  white-space: nowrap;
  padding: 12px 16px;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  color: white;
  cursor: pointer;
}

.PanelWriteOff_addProduct__IU232 {
  margin-right: 10px;
  background-color: rgba(29, 135, 82, 1);
}

.PanelWriteOff_endProduct__\\+o8PF {
  background-color: black;
}

.PanelWriteOff_suggestionList__YUiGX {
  top: 30px;
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  width: 73.1%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 5px;
  padding: 0;
  list-style: none;
}

.PanelWriteOff_suggestionItem__NrfF3 {
  padding: 10px;
  cursor: pointer;
}

.PanelWriteOff_suggestionItem__NrfF3:hover {
  background-color: #f0f0f0;
}


.PanelWriteOff_productTable__1\\+\\+kD {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.PanelWriteOff_productTable__1\\+\\+kD th,
.PanelWriteOff_productTable__1\\+\\+kD td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.PanelWriteOff_productTable__1\\+\\+kD th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333
}

.PanelWriteOff_productTable__1\\+\\+kD tr:hover {
  background-color: #f5f5f5;
}

.PanelWriteOff_changeNum__ox5Tg {
    padding: 5px 0 5px 5px;
    margin-right: 3px;
    border: #333 1px solid;
    background: white;
    border-radius: 3px;
}

.PanelWriteOff_clickable__PFQre {
    cursor: pointer;
}

/* затемнение фона */
.PanelWriteOff_modalOverlay__HPqB- {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* сама модалка */
.PanelWriteOff_modal__3vLfI {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
  animation: PanelWriteOff_fadeIn__0mEQk 0.25s ease;
}

/* заголовок */
.PanelWriteOff_modal__3vLfI h3 {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* поле комментария */
.PanelWriteOff_commentInput__MRsvk {
  width: 100%;
  min-height: 80px;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}
.PanelWriteOff_commentInput__MRsvk:focus {
  border-color: #007bff;
}

/* кнопки внутри модалки */
.PanelWriteOff_modalActions__VEOKq {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
}

.PanelWriteOff_modalActions__VEOKq button {
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.PanelWriteOff_modalActions__VEOKq button:first-child {
  background: gray;
  color: white;
}
.PanelWriteOff_modalActions__VEOKq button:first-child:hover {
  background: #b5b5b5;
}

.PanelWriteOff_modalActions__VEOKq button:last-child {
  background:  rgba(29, 135, 82, 1);
  color: white;
}
.PanelWriteOff_modalActions__VEOKq button:last-child:hover {
  background:  rgba(29, 135, 82, 1);
  transform: scale(1.02);
}

/* анимация появления */
@keyframes PanelWriteOff_fadeIn__0mEQk {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/PanelWriteOff.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAya;IACza,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,iDAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".PanelWriteOff {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 85%;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.backButton {\n    display: flex;\n    align-items: center;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 15px;\n    height: 16.2px;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.backText {\n    font-weight: bold;\n    font-size: 18px;\n    padding-left: 20px;\n}\n\n.text {\n    margin-bottom: 10px;\n    color: rgb(108, 106, 106);\n}\n\n.title {\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: black;\n}\n\n.change {\n    color: rgba(29, 135, 82, 1);\n}\n\n.content {\n    gap: 20px;\n    display: flex;\n}\n\n.content div {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 200px;\n    border-radius: 5px;\n    padding: 1.25rem 1.25rem;\n    background: white;\n}\n\n.secondBlock .price {\n    color: brown;\n    font-size: 28px;\n}\n\n.thirdBlock .price {\n    font-size: 28px;\n    color: blue;\n}\n\n.fourthBlock .price {\n    font-size: 28px;\n    color: chocolate;\n}\n\n.searchBlock {\n  position: relative;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.search {\n  flex: 1;\n  padding: 10px 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #ccc;\n}\n\n.addProduct,\n.endProduct {\n  white-space: nowrap;\n  padding: 12px 16px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.addProduct {\n  margin-right: 10px;\n  background-color: rgba(29, 135, 82, 1);\n}\n\n.endProduct {\n  background-color: black;\n}\n\n.suggestionList {\n  top: 30px;\n  position: absolute;\n  background: #fff;\n  border: 1px solid #ccc;\n  width: 73.1%;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  margin-top: 5px;\n  padding: 0;\n  list-style: none;\n}\n\n.suggestionItem {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestionItem:hover {\n  background-color: #f0f0f0;\n}\n\n\n.productTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.productTable th,\n.productTable td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.productTable th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333\n}\n\n.productTable tr:hover {\n  background-color: #f5f5f5;\n}\n\n.changeNum {\n    padding: 5px 0 5px 5px;\n    margin-right: 3px;\n    border: #333 1px solid;\n    background: white;\n    border-radius: 3px;\n}\n\n.clickable {\n    cursor: pointer;\n}\n\n/* затемнение фона */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n/* сама модалка */\n.modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.25s ease;\n}\n\n/* заголовок */\n.modal h3 {\n  margin: 0 0 16px;\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n}\n\n/* поле комментария */\n.commentInput {\n  width: 100%;\n  min-height: 80px;\n  resize: none;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n.commentInput:focus {\n  border-color: #007bff;\n}\n\n/* кнопки внутри модалки */\n.modalActions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.modalActions button {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.modalActions button:first-child {\n  background: gray;\n  color: white;\n}\n.modalActions button:first-child:hover {\n  background: #b5b5b5;\n}\n\n.modalActions button:last-child {\n  background:  rgba(29, 135, 82, 1);\n  color: white;\n}\n.modalActions button:last-child:hover {\n  background:  rgba(29, 135, 82, 1);\n  transform: scale(1.02);\n}\n\n/* анимация появления */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PanelWriteOff": `PanelWriteOff_PanelWriteOff__TcSC7`,
	"header": `PanelWriteOff_header__F7V-8`,
	"backButton": `PanelWriteOff_backButton__JZB4O`,
	"backText": `PanelWriteOff_backText__Mj8U4`,
	"text": `PanelWriteOff_text__4hMle`,
	"title": `PanelWriteOff_title__7HxvF`,
	"change": `PanelWriteOff_change__eiUgl`,
	"content": `PanelWriteOff_content__m00WJ`,
	"secondBlock": `PanelWriteOff_secondBlock__HP7q0`,
	"price": `PanelWriteOff_price__l+Ibv`,
	"thirdBlock": `PanelWriteOff_thirdBlock__bis9b`,
	"fourthBlock": `PanelWriteOff_fourthBlock__3HWCZ`,
	"searchBlock": `PanelWriteOff_searchBlock__iRqls`,
	"search": `PanelWriteOff_search__T20DJ`,
	"addProduct": `PanelWriteOff_addProduct__IU232`,
	"endProduct": `PanelWriteOff_endProduct__+o8PF`,
	"suggestionList": `PanelWriteOff_suggestionList__YUiGX`,
	"suggestionItem": `PanelWriteOff_suggestionItem__NrfF3`,
	"productTable": `PanelWriteOff_productTable__1++kD`,
	"changeNum": `PanelWriteOff_changeNum__ox5Tg`,
	"clickable": `PanelWriteOff_clickable__PFQre`,
	"modalOverlay": `PanelWriteOff_modalOverlay__HPqB-`,
	"modal": `PanelWriteOff_modal__3vLfI`,
	"fadeIn": `PanelWriteOff_fadeIn__0mEQk`,
	"commentInput": `PanelWriteOff_commentInput__MRsvk`,
	"modalActions": `PanelWriteOff_modalActions__VEOKq`
};
export default ___CSS_LOADER_EXPORT___;
